<div id="wrapper">
  <div class="container">
    <mat-form-field appearance="fill" appearance="outline" class="search-form-field" color="accent">
      <!-- <mat-label>Search Groups</mat-label> -->
      <input (input)="onSearch()" [(ngModel)]="searchText" placeholder="please input the Business Partner Number" matInput>
      <mat-icon matPrefix>search</mat-icon>
      <button (click)="searchText=''; onSearch()" *ngIf="searchText" mat-icon-button matSuffix>
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>

    <button (click)="onCreate()" color="accent" mat-stroked-button>
      <mat-icon>add_circle_outline</mat-icon>
      Configure Partner Group
    </button>
  </div>
  <div fxLayout="row wrap" fxLayoutAlign="start start">
    <mat-card *ngIf="partnerGroupsInfo" class="partnerGroups-card">
      <mat-card-header>
        <mat-icon mat-card-avatar></mat-icon>
        <mat-card-title>{{partnerGroupsInfo['@id']}}</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <mat-list dense>
          <mat-list-item>
            <mat-icon matListItemIcon>info</mat-icon>
            <div class="partnerGroups-property" matListItemTitle>Groups</div>
            <div matListItemLine>{{partnerGroupsInfo['tx:groups']}}</div>
          </mat-list-item>
        </mat-list>
      </mat-card-content>
      <mat-divider inset></mat-divider>
      <mat-card-actions class="card-actions">
        <button (click)="onDelete(partnerGroupsInfo['@id'])" [disabled]="isBusy()" color="warn" mat-stroked-button>
          <mat-icon>delete_sweep</mat-icon> Delete
        </button>
        <button (click)="onUpdate(partnerGroupsInfo)" [disabled]="isBusy()" color="warn" mat-stroked-button>
          <mat-icon>update_sweep</mat-icon> Update
        </button>
      </mat-card-actions>
      <mat-card-footer>
        <mat-progress-bar *ngIf="isBusy()" color="accent" mode="indeterminate"></mat-progress-bar>
      </mat-card-footer>
    </mat-card>
  </div>
</div>
